module.exports = __webpack_public_path__ + "img/cloud.2387db31.png";